import createFencePricingModule from "./fence-pricing-module";

// The same pricing structure, kept in HUB's own db so it can diverge from the configurator's.
// Only this store carries the model list and its slat geometry - the configurator keeps its own.
export default createFencePricingModule("api/fence-pricing/", { models: true });
